import React, {Component} from 'react';
import './multipleChoiceAnswer.css';

export class CheckboxAnswer extends Component {
  componentWillUnmount() {
    this.props.clearSurvey?.();
  }

  toggleAnswer = option => {
    const {question, answer, onChange} = this.props;
    const available = question.options?.options || [];
    const maximum = question.options?.maxSelected ?? available.length;
    const selected = (answer?.answer || []).filter(value => available.includes(value));
    const index = selected.indexOf(option);

    if (index >= 0) {
      selected.splice(index, 1);
    } else if (selected.length < maximum) {
      selected.push(option);
    } else if (maximum > 0) {
      selected.splice(selected.length - 1, 1, option);
    }
    onChange?.(selected, true);
  };

  render() {
    const {question, answer, tabIndex} = this.props;
    const selected = answer?.answer || [];
    return <div className="br-survey-choice-answer" role="group"
      aria-label={question.question || 'Choose options'}>
      {(question.options?.options || []).map((option, index) => <label
        className={`br-survey-choice-answer__option${selected.includes(option) ? ' br-survey-choice-answer__option--selected' : ''}`}
        key={index}>
        <input type="checkbox" checked={selected.includes(option)}
          onChange={() => this.toggleAnswer(option)} tabIndex={tabIndex} />
        <span>{option}</span>
      </label>)}
    </div>;
  }
}

export default CheckboxAnswer;
